import { render, staticRenderFns } from "./AddClient.vue?vue&type=template&id=6b6d3e8e&scoped=true&"
import script from "./AddClient.vue?vue&type=script&lang=ts&"
export * from "./AddClient.vue?vue&type=script&lang=ts&"
import style0 from "./AddClient.vue?vue&type=style&index=0&id=6b6d3e8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d3e8e",
  null
  
)

export default component.exports